import DapDSDataTable from './datatable.component'

export * from './datatable.component'
export default DapDSDataTable

DapDSDataTable.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-datatable': DapDSDataTable<unknown>
  }
}
